
import { IGiftCardItem } from '@core/interfaces/cart/giftcard-item.interface';


export class GiftCardItem implements IGiftCardItem {

  readonly name: string;
  readonly availableAmount: number;
  readonly vat: number;
  readonly amount: number;
  readonly couponId: string;

  constructor(iGiftCardItem: IGiftCardItem) {
    this.name = iGiftCardItem.name;
    this.availableAmount = iGiftCardItem.availableAmount;
    this.vat = iGiftCardItem.vat;
    this.amount = iGiftCardItem.amount;
    this.couponId = iGiftCardItem.couponId;
  }

}
